export default {
    testValue: 1,
    gameOn: false,
    inRound: false,
    isPaused: false,
    redTeam: true,
    blueScore: 0,
    redScore: 0,
    phase: 0,
    timerValue: 60,
    deck: ['a1','a2','a3', 'a4'],
    remainingCards: ['b1', 'b2', 'b3', 'b4'],
    instructions: false,
    redTempScore: 0,
    redCard: 0,
    redPass: 0,
    blueTempScore: 0,
    blueCard: 0,
    bluePass: 0
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js